export default "__VITE_ASSET__h4y6CvhI__"